import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AccessibilityMenu } from './AccessibilityMenu';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-white focus:text-blue-600">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="flex-grow" role="main">{children}</main>
      <AccessibilityMenu />
      <Footer />
    </div>
  );
}